// extracted by mini-css-extract-plugin
module.exports = {"SmallContainer":"SmallContainer_hxcsq"};